// @mui

import { TableRow, TableCell } from '@mui/material';
import EmptyContent from '../EmptyContent';

// ----------------------------------------------------------------------

type Props = {
  isNotFound: boolean;
  title?: string;
};

export default function TableNoData({ isNotFound, title = 'No Data' }: Props) {
  return (
    <>
      {isNotFound ? (
        <TableRow>
          <TableCell colSpan={20}>
            <EmptyContent
              title={title}
              sx={{
                '& span.MuiBox-root': { height: 160 },
              }}
            />
          </TableCell>
        </TableRow>
      ) : (
        <TableRow>
          <TableCell colSpan={9} sx={{ p: 0 }} />
        </TableRow>
      )}
    </>
  );
}
